// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3SO4i","list":"BalanceDue_list__21duz","listRow":"BalanceDue_listRow__1Du-K","total":"BalanceDue_total__i9gfd"};